// extracted by mini-css-extract-plugin
export default {"paddingRightMd":"_2NW5J-l5","paddingLeftMd":"Fm92yRLk","projectPanel":"N1g-5htC","tabs":"f2iCikDO"};